<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-13 16:44:19
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-20 15:00:38
 * @Description: 动态共享
-->
<template>
  <div class="home-case-share">
    <!-- 首页功能模块共用组件 -->
    <func-module
      title="动态共享"
      icon="icon-fenxiang1"
      rowColor="#ebf7fd"
      publishColor="#50bfee"
      hoverColor="#49afda"
      :listData="data.list"
      :tips="caseShareTips"
      @intoDetail="intoCaseShareDetail"
      @hanleViewAll="getAllCaseShareData"
      @handlePublish="handlePublish"
    >
      <template #row="{item}">
        <div class="row">
          <div class="row-left">
            {{ item.postTitle }}
          </div>
          <div class="row-right">
            <span class="size" v-if="item.tp == '6'">
              {{ item.userName + (item.pDName ? "(" + item.pDName + ")" : "") }}
            </span>
            <span class="size" v-else>
              {{ item.userName + (item.dName ? "(" + item.dName + ")" : "") }}
            </span>
            <span class="time">{{ item.createTm | dateFormat }}</span>
          </div>
        </div>
      </template>
    </func-module>
    <!-- 发布动态共享 -->
    <post-create
      :hasAttachment="true"
      :hasCaseShare="true"
      title="发布动态共享"
      :tips="caseShareTips"
      @sensitiveWord="sensitiveWord"
      :visible.sync="postCreateVisible"
      :baseUrl="baseUrl"
      @refresh="queryData"
    />
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import animation from "@/components/loading/animation";
import PostCreate from "@/components/detail/PostCreate.vue";
import FuncModule from "@/components/common/FuncModule";
export default {
  name: "CaseShareComponent",
  components: { PostCreate, animation, FuncModule },
  data() {
    return {
      this_: this,
      data: {
        list: [],
        isLoading: false,
        pageNum: 1,
        pageSize: 9
      },
      dialog: {
        isShow: false,
        caseId: null,
        editFlag: "view"
      },
      fileIconType: {
        ppt: "icon-file-ppt-fill",
        xls: "icon-file-excel-fill",
        xlsx: "icon-file-excel-fill",
        word: "icon-file-word-fill",
        pdf: "icon-PDF"
      },

      postCreateVisible: false,
      baseUrl: "/eims-api/caseShare/create"
    };
  },
  created() {
    this.queryData();
  },
  filters: {},
  methods: {
    closeDialog() {
      this.dialog.isShow = false;
      this.dialog.editFlag = "view";
      this.dialog.caseId = null;
    },
    queryData() {
      let _this = this;
      http
        .post(window.config.api.baseUrl + "/eims-api/caseShare/list", {
          token: cookie.getCookie("token"),
          data: {
            pageNum: _this.data.pageNum,
            pageSize: _this.data.pageSize
          }
        })
        .then(function(response) {
          let data = response.data.data;
          _this.data.list = data.articles;
          _this.data.pageNum = 1;
        })
        .finally(() => {
          // _this.data.isLoading = false;
        });
    },
    getAllCaseShareData() {
      this.$store.dispatch("clearFindParam", {});
      this.$router.push({ path: "/caseShare/list" });
    },
    handlePublish() {
      this.postCreateVisible = true;
    },
    intoCaseShareDetail(row) {
      this.$store.dispatch("findCaseShareDetail", { postCode: row.postCode });
      this.$router.push({
        path: "caseShare/view"
      });
    },
    caseShareFileDown() {},
    caseShareFilePrev(row) {
      this.$router.push({
        path: "caseShare/view",
        query: {
          caseId: row.id
        }
      });
    },
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.home-case-share {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-family: SourceHanSansSC;
  .row {
    background: rgb(235, 247, 253);
    display: flex;
    justify-content: space-between;
    .row-left {
      // width: calc(100% - min(35%, 380px));
      width: 70%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 5px;
      font-size: 18px;
      font-weight: bold;
    }
    .row-right {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      // width: calc(min(35%, 380px));
      width: 30%;
      color: rgb(51, 51, 51);
      line-height: 20px;
      .size {
        width: calc(100% / 3 * 2);
        color: rgb(153, 153, 153);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .time {
        margin: 0 10px;
        width: calc(100% / 3 * 1);
        color: rgb(153, 153, 153);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/CaseShareComponent.vue